import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { D1PdfPageSelectionEdit } from "./edit";
import { D1PdfPageSelectionNew } from "./new";
import { D1PdfPageSelectionTable } from "./table";

export default function D1PdfPageSelection() {
  const { t, i18n } = useTranslation(["titles"]);

  useEffect(() => {
    setDocumentTitle(
      t("quantilia_s_lection_de_pages_pdf", {
        ns: "titles",
        defaultValue: "Quantilia | PDF Page Selection",
      }),
    );
  }, [t, i18n.language]);

  return (
    <Routes>
      <Route path=":id" element={<D1PdfPageSelectionEdit />} />
      <Route index element={<D1PdfPageSelectionTable />} />
      <Route path="/new" element={<D1PdfPageSelectionNew />} />
    </Routes>
  );
}
